import withStyles from "@material-ui/core/styles/withStyles";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import emptyImgae from "Assets/Svg/career-page.svg";

import Grid from "@material-ui/core/Grid";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class OurCulture extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      value: 0,
      imgcount: 2,
      isImages: true,
    };
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleChange = (event, value, id) => {
    this.setState({ value, id }, () => {});
  };

  handleTabChange(value) {
    this.setState({
      value,
    });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { imgcount, isImages } = this.state;
    return (
      <Grid container spacing={3} style={{ marginBottom: 64 }}>
        <Grid item xs={12} md={8} sm={12}>
          <p className="small-dark-secondary margin-bottom-16">OUR CULTURE</p>
          <h6 className="section-title">Who we are</h6>
          <p className="small-dark-secondary margin-bottom-16">
            We are building an enduring company and a platform that emphasizes
            the value of human interactions and connection. We put the customer
            at the center of everything we do.
          </p>
        </Grid>
        <Grid item xs={12} md={4} sm={12}>
          {isImages ? (
            <div className="text-center width100 position-rel">
              <img
                src={emptyImgae}
                height="200"
                width="200"
                style={{
                  position: "absolute",
                  border: "1px solid #ddd",
                  zIndex: 0,
                  background: "#fff",
                  top: 0,
                  left: 0,
                }}
              ></img>
              {imgcount == 2 ? (
                <img
                  src={emptyImgae}
                  height="200"
                  width="200"
                  style={{
                    position: "absolute",
                    border: "1px solid #ddd",
                    zIndex: 0,
                    background: "#fff",
                    top: 32,
                    left: 64,
                  }}
                ></img>
              ) : (
                <div
                  style={{
                    position: "absolute",
                    border: "4px solid #1e8ced",
                    zIndex: 1,
                    width: 200,
                    height: 200,
                    top: 32,
                    left: 64,
                  }}
                ></div>
              )}
              <img
                src={emptyImgae}
                height="200"
                width="200"
                style={{
                  border: "1px solid #ddd",
                  position: "absolute",
                  zIndex: 2,
                  background: "#fff",
                  top: 82,
                  left: 128,
                }}
              ></img>
            </div>
          ) : (
            <div style={{ height: "100%", width: "100%" }}>Video</div>
          )}
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(OurCulture)));
